var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CertificatType-main",class:{ 'CertificatType-main-mobile': _vm.isMobile }},_vm._l((_vm.dataList),function(item){return _c('CertificatTypeItem',{key:item.id,attrs:{"data":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }